import { cva } from '@/styled-system/css';

// The option cards, radio mark, and tag are styled through PandaCSS recipes (not native `style` with raw
// `var(--colors-*)` refs) so the token-backed colors are extracted at build time and survive the production build.

export const optionCardRecipe = cva({
  base: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '14px',
    padding: '16px 18px',
    borderRadius: '14px',
    borderWidth: '2px',
    borderStyle: 'solid',
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
    outlineOffset: '2px',
    // Only show the focus ring for keyboard focus, so a mouse click doesn't draw a second line over the
    // selected border.
    '&:has(input:focus-visible)': {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: '{colors.border.accent.blue.strong}',
    },
  },
  variants: {
    selected: {
      true: { borderColor: '{colors.border.accent.blue.strong}', backgroundColor: '{colors.blue.50}' },
      false: { borderColor: '{colors.border.neutral}', backgroundColor: '{colors.bg.neutral}' },
    },
  },
  defaultVariants: { selected: false },
});

export const radioMarkRecipe = cva({
  base: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    borderWidth: '1.5px',
    borderStyle: 'solid',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginTop: '1px',
  },
  variants: {
    selected: {
      true: { borderColor: '{colors.border.accent.blue.strong}', backgroundColor: '{colors.bg.accent.blue.impact}' },
      false: { borderColor: '{colors.border.neutral}', backgroundColor: '{colors.bg.neutral}' },
    },
  },
  defaultVariants: { selected: false },
});

export const optionTagRecipe = cva({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    height: '19px',
    padding: '0 8px',
    borderRadius: '999px',
    fontSize: '10.5px',
    fontWeight: 700,
    letterSpacing: '0.03em',
    whiteSpace: 'nowrap',
  },
  variants: {
    selected: {
      true: { backgroundColor: '{colors.bg.accent.blue.soft}', color: '{colors.text.accent.blue.strong}' },
      false: { backgroundColor: '{colors.bg.softer}', color: '{colors.text.subtle}' },
    },
  },
  defaultVariants: { selected: false },
});
